module.exports = __webpack_public_path__ + "img/minting-grid.4ad3e830.png";